// extracted by mini-css-extract-plugin
module.exports = {"generalContainer":"removeScholarships_generalContainer__3trvI","select_wrapper":"removeScholarships_select_wrapper__2oepb"};